export const environment = {
  apiUrl: '/api/',
  envName: 'prod',
  production: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts